module.exports = __webpack_public_path__ + "static/media/yourtickles.526518ce.wav";